/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../../graphql/src/lib/graphql/generated/types'
import { CallButtonVehicleFragmentDoc } from '../CallButton/CallButton.hook'

const defaultOptions = {} as const
export type CallControlsVehicleFragment = {
  __typename?: 'Vehicle'
  id: string
  fccCurrentAdAlerts: {
    __typename?: 'FccAdAlerts'
    alerts: Array<{
      __typename?: 'FccAdAlert'
      id: string
      type: Types.FccAdAlertType
    }>
  } | null
}

export type FccJoinPassengerCallMutationVariables = Types.Exact<{
  vehicleId: Types.Scalars['ID']['input']
}>

export type FccJoinPassengerCallMutation = {
  __typename?: 'Mutation'
  fccJoinPassengerCall: string
}

export type FccJoinSafetyDriverCallMutationVariables = Types.Exact<{
  vehicleId: Types.Scalars['ID']['input']
}>

export type FccJoinSafetyDriverCallMutation = {
  __typename?: 'Mutation'
  fccJoinSafetyDriverCall: string
}

export type CallButtonStartHandlingVehicleMutationVariables = Types.Exact<{
  vehicleId: Types.Scalars['ID']['input']
}>

export type CallButtonStartHandlingVehicleMutation = {
  __typename?: 'Mutation'
  fccStartHandlingVehicle: any | null
}

export type FccInitiateOperatorToPassengerCallMutationVariables = Types.Exact<{
  vehicleId: Types.Scalars['ID']['input']
  emergencyStopAlertId?: Types.InputMaybe<Types.Scalars['ID']['input']>
}>

export type FccInitiateOperatorToPassengerCallMutation = {
  __typename?: 'Mutation'
  fccInitiateOperatorToPassengerCall: string
}

export type FccInitiateOperatorToSafetyDriverCallMutationVariables =
  Types.Exact<{
    vehicleId: Types.Scalars['ID']['input']
  }>

export type FccInitiateOperatorToSafetyDriverCallMutation = {
  __typename?: 'Mutation'
  fccInitiateOperatorToSafetyDriverCall: string
}

export const CallControlsVehicleFragmentDoc = gql`
    fragment CallControlsVehicle on Vehicle {
  id
  fccCurrentAdAlerts {
    alerts {
      id
      type
    }
  }
  ...CallButtonVehicle
}
    ${CallButtonVehicleFragmentDoc}`
export const FccJoinPassengerCallDocument = gql`
    mutation FccJoinPassengerCall($vehicleId: ID!) {
  fccJoinPassengerCall(input: {vehicleId: $vehicleId})
}
    `
export type FccJoinPassengerCallMutationFn = Apollo.MutationFunction<
  FccJoinPassengerCallMutation,
  FccJoinPassengerCallMutationVariables
>

/**
 * __useFccJoinPassengerCallMutation__
 *
 * To run a mutation, you first call `useFccJoinPassengerCallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFccJoinPassengerCallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fccJoinPassengerCallMutation, { data, loading, error }] = useFccJoinPassengerCallMutation({
 *   variables: {
 *      vehicleId: // value for 'vehicleId'
 *   },
 * });
 */
export function useFccJoinPassengerCallMutation(
  baseOptions?: Apollo.MutationHookOptions<
    FccJoinPassengerCallMutation,
    FccJoinPassengerCallMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    FccJoinPassengerCallMutation,
    FccJoinPassengerCallMutationVariables
  >(FccJoinPassengerCallDocument, options)
}
export type FccJoinPassengerCallMutationHookResult = ReturnType<
  typeof useFccJoinPassengerCallMutation
>
export type FccJoinPassengerCallMutationResult =
  Apollo.MutationResult<FccJoinPassengerCallMutation>
export type FccJoinPassengerCallMutationOptions = Apollo.BaseMutationOptions<
  FccJoinPassengerCallMutation,
  FccJoinPassengerCallMutationVariables
>
export const FccJoinSafetyDriverCallDocument = gql`
    mutation FccJoinSafetyDriverCall($vehicleId: ID!) {
  fccJoinSafetyDriverCall(input: {vehicleId: $vehicleId})
}
    `
export type FccJoinSafetyDriverCallMutationFn = Apollo.MutationFunction<
  FccJoinSafetyDriverCallMutation,
  FccJoinSafetyDriverCallMutationVariables
>

/**
 * __useFccJoinSafetyDriverCallMutation__
 *
 * To run a mutation, you first call `useFccJoinSafetyDriverCallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFccJoinSafetyDriverCallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fccJoinSafetyDriverCallMutation, { data, loading, error }] = useFccJoinSafetyDriverCallMutation({
 *   variables: {
 *      vehicleId: // value for 'vehicleId'
 *   },
 * });
 */
export function useFccJoinSafetyDriverCallMutation(
  baseOptions?: Apollo.MutationHookOptions<
    FccJoinSafetyDriverCallMutation,
    FccJoinSafetyDriverCallMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    FccJoinSafetyDriverCallMutation,
    FccJoinSafetyDriverCallMutationVariables
  >(FccJoinSafetyDriverCallDocument, options)
}
export type FccJoinSafetyDriverCallMutationHookResult = ReturnType<
  typeof useFccJoinSafetyDriverCallMutation
>
export type FccJoinSafetyDriverCallMutationResult =
  Apollo.MutationResult<FccJoinSafetyDriverCallMutation>
export type FccJoinSafetyDriverCallMutationOptions = Apollo.BaseMutationOptions<
  FccJoinSafetyDriverCallMutation,
  FccJoinSafetyDriverCallMutationVariables
>
export const CallButtonStartHandlingVehicleDocument = gql`
    mutation CallButtonStartHandlingVehicle($vehicleId: ID!) {
  fccStartHandlingVehicle(vehicleId: $vehicleId)
}
    `
export type CallButtonStartHandlingVehicleMutationFn = Apollo.MutationFunction<
  CallButtonStartHandlingVehicleMutation,
  CallButtonStartHandlingVehicleMutationVariables
>

/**
 * __useCallButtonStartHandlingVehicleMutation__
 *
 * To run a mutation, you first call `useCallButtonStartHandlingVehicleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCallButtonStartHandlingVehicleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [callButtonStartHandlingVehicleMutation, { data, loading, error }] = useCallButtonStartHandlingVehicleMutation({
 *   variables: {
 *      vehicleId: // value for 'vehicleId'
 *   },
 * });
 */
export function useCallButtonStartHandlingVehicleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CallButtonStartHandlingVehicleMutation,
    CallButtonStartHandlingVehicleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CallButtonStartHandlingVehicleMutation,
    CallButtonStartHandlingVehicleMutationVariables
  >(CallButtonStartHandlingVehicleDocument, options)
}
export type CallButtonStartHandlingVehicleMutationHookResult = ReturnType<
  typeof useCallButtonStartHandlingVehicleMutation
>
export type CallButtonStartHandlingVehicleMutationResult =
  Apollo.MutationResult<CallButtonStartHandlingVehicleMutation>
export type CallButtonStartHandlingVehicleMutationOptions =
  Apollo.BaseMutationOptions<
    CallButtonStartHandlingVehicleMutation,
    CallButtonStartHandlingVehicleMutationVariables
  >
export const FccInitiateOperatorToPassengerCallDocument = gql`
    mutation FccInitiateOperatorToPassengerCall($vehicleId: ID!, $emergencyStopAlertId: ID) {
  fccInitiateOperatorToPassengerCall(
    input: {vehicleId: $vehicleId, emergencyStopAlertId: $emergencyStopAlertId}
  )
}
    `
export type FccInitiateOperatorToPassengerCallMutationFn =
  Apollo.MutationFunction<
    FccInitiateOperatorToPassengerCallMutation,
    FccInitiateOperatorToPassengerCallMutationVariables
  >

/**
 * __useFccInitiateOperatorToPassengerCallMutation__
 *
 * To run a mutation, you first call `useFccInitiateOperatorToPassengerCallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFccInitiateOperatorToPassengerCallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fccInitiateOperatorToPassengerCallMutation, { data, loading, error }] = useFccInitiateOperatorToPassengerCallMutation({
 *   variables: {
 *      vehicleId: // value for 'vehicleId'
 *      emergencyStopAlertId: // value for 'emergencyStopAlertId'
 *   },
 * });
 */
export function useFccInitiateOperatorToPassengerCallMutation(
  baseOptions?: Apollo.MutationHookOptions<
    FccInitiateOperatorToPassengerCallMutation,
    FccInitiateOperatorToPassengerCallMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    FccInitiateOperatorToPassengerCallMutation,
    FccInitiateOperatorToPassengerCallMutationVariables
  >(FccInitiateOperatorToPassengerCallDocument, options)
}
export type FccInitiateOperatorToPassengerCallMutationHookResult = ReturnType<
  typeof useFccInitiateOperatorToPassengerCallMutation
>
export type FccInitiateOperatorToPassengerCallMutationResult =
  Apollo.MutationResult<FccInitiateOperatorToPassengerCallMutation>
export type FccInitiateOperatorToPassengerCallMutationOptions =
  Apollo.BaseMutationOptions<
    FccInitiateOperatorToPassengerCallMutation,
    FccInitiateOperatorToPassengerCallMutationVariables
  >
export const FccInitiateOperatorToSafetyDriverCallDocument = gql`
    mutation FccInitiateOperatorToSafetyDriverCall($vehicleId: ID!) {
  fccInitiateOperatorToSafetyDriverCall(input: {vehicleId: $vehicleId})
}
    `
export type FccInitiateOperatorToSafetyDriverCallMutationFn =
  Apollo.MutationFunction<
    FccInitiateOperatorToSafetyDriverCallMutation,
    FccInitiateOperatorToSafetyDriverCallMutationVariables
  >

/**
 * __useFccInitiateOperatorToSafetyDriverCallMutation__
 *
 * To run a mutation, you first call `useFccInitiateOperatorToSafetyDriverCallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFccInitiateOperatorToSafetyDriverCallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fccInitiateOperatorToSafetyDriverCallMutation, { data, loading, error }] = useFccInitiateOperatorToSafetyDriverCallMutation({
 *   variables: {
 *      vehicleId: // value for 'vehicleId'
 *   },
 * });
 */
export function useFccInitiateOperatorToSafetyDriverCallMutation(
  baseOptions?: Apollo.MutationHookOptions<
    FccInitiateOperatorToSafetyDriverCallMutation,
    FccInitiateOperatorToSafetyDriverCallMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    FccInitiateOperatorToSafetyDriverCallMutation,
    FccInitiateOperatorToSafetyDriverCallMutationVariables
  >(FccInitiateOperatorToSafetyDriverCallDocument, options)
}
export type FccInitiateOperatorToSafetyDriverCallMutationHookResult =
  ReturnType<typeof useFccInitiateOperatorToSafetyDriverCallMutation>
export type FccInitiateOperatorToSafetyDriverCallMutationResult =
  Apollo.MutationResult<FccInitiateOperatorToSafetyDriverCallMutation>
export type FccInitiateOperatorToSafetyDriverCallMutationOptions =
  Apollo.BaseMutationOptions<
    FccInitiateOperatorToSafetyDriverCallMutation,
    FccInitiateOperatorToSafetyDriverCallMutationVariables
  >
